import styled, { css } from 'styled-components/macro';
import { ImageStyled } from '@yme/atoms/image';
import { NavigationStyled } from '@yme/components/Error404/Navigation/styled';
import { colorBlackTransparent300, HERO_SECTION_BACKGROUND_SECOND } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { commonTextShadow, HeadingLevel1, HeadingLevel4 } from '@yme/tokens/typography';
export const HeroComponentStyled = styled.div `
  position: relative;

  min-height: 202px;

  ${ADAPTIVE.minWidth.tablet} {
    min-height: 432px;
  }

  @media only screen and (min-width: 768px) and (min-height: 1180px) {
    min-height: 40vh;
  }

  @media only screen and (min-width: 912px) and (min-height: 1180px) {
    min-height: 50vh;
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: 810px;
  }

  @media only screen and (min-width: 1920px) and (min-height: 1080px) {
    min-height: 1000px;
  }
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }

  ${ImageStyled} {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  width: 100%;
  padding: 64px 0 16px;

  ${ADAPTIVE.minWidth.tablet} {
    justify-content: flex-start;
    padding-top: 128px;
    padding-bottom: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 659px;
    padding-bottom: 120px;
    padding-top: 350px;
  }
`;
export const SubTitleStyled = styled(HeadingLevel4) `
  ${commonTextShadow}
`;
export const TitleStyled = styled(HeadingLevel1) `
  ${commonTextShadow}
`;
export const PageContainerStyled = styled.div `
  ${({ isHidden }) => isHidden &&
    css `
      ${NavigationStyled} {
        display: none;
      }
    `}
`;
